import React from 'react';
import './contacts.scss';
import { Col, Container, Row } from 'react-bootstrap';

function Contacts() {
  return (
      <div id="contacts" className="contacts pt50 mb40">
        <Container>
          <Row>
            <Col sm={12} className="mb50">
              <div className="section-title">Let's Plan Your Visit</div>
            </Col>

            <Col sm={6} className="address">
              <h3 className="mb40">We'd Love to Hear from You</h3>

              <Row>
                <Col sm={2} className="label">
                  Location
                </Col>
                <Col sm={10}>
                  After the Rock of Chasampoulion,<br />
                  before Kidasi Village,<br />
                  4774, Cyprus
                </Col>
              </Row>

              <Row>
                <Col sm={2} className="label">
                  Phone
                </Col>
                <Col sm={10}>
                  +357 99 514 991
                </Col>
              </Row>

              <Row>
                <Col sm={2} className="label">
                  Email
                </Col>
                <Col sm={10}>
                  info@amazing-world.eu
                </Col>
              </Row>
            </Col>

            <Col sm={6}></Col>
          </Row>
        </Container>
      </div>
  );
}

export default Contacts;